import { Check, Info } from "lucide-react";
import { Reveal, Eyebrow, GoldDivider } from "./Reveal";

const BENEFITS = [
  "Understand their child's individual Ayurvedic pattern",
  "Explore functional patterns beyond a diagnosis",
  "Receive personalized diet and lifestyle guidance",
  "Understand relevant speech, attention, sensory, sleep, digestion and behavioral patterns",
  "Learn practical ways to support their child at home",
  "Receive guidance based on the selected consultation pathway",
];

export default function WhySection() {
  return (
    <section data-testid="why-section" className="bg-[#F4EFE6] py-16 lg:py-28 border-y border-[#E5D3AD]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20">
        <Reveal>
          <Eyebrow>Chapter 02 · The Consultation</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] tracking-tight leading-tight">
            More Than a Consultation. A <em className="italic text-[#B85D43]">Deeper Understanding</em> of Your Child.
          </h2>
          <p className="mt-6 text-base text-[#5C6E62] leading-relaxed">
            This consultation is designed to help parents see their child's individual pattern more clearly — and leave
            with guidance they can actually use at home.
          </p>
          <GoldDivider className="!mx-0 mt-8" />
          <div
            data-testid="responsible-disclaimer"
            className="mt-8 flex gap-3 bg-[#FAF7F2] border border-[#E5D3AD]/60 rounded-2xl p-5"
          >
            <Info className="w-5 h-5 text-[#C5A059] shrink-0 mt-0.5" />
            <p className="text-xs text-[#5C6E62] leading-relaxed">
              Ayurvedic consultations are complementary and personalized. They are not a replacement for appropriate
              medical, developmental, therapeutic or emergency care.
            </p>
          </div>
        </Reveal>

        <div className="flex flex-col justify-center gap-4">
          {BENEFITS.map((b, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <div className="flex items-start gap-4 bg-[#FAF7F2] rounded-2xl px-6 py-5 border border-[#E5D3AD]/40 hover:border-[#C5A059] transition-colors duration-300">
                <span className="mt-0.5 w-6 h-6 rounded-full bg-[#1B3B2B] flex items-center justify-center shrink-0">
                  <Check className="w-3.5 h-3.5 text-[#C5A059]" />
                </span>
                <p className="text-sm sm:text-base text-[#2D3A32] leading-relaxed">{b}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
